import gql from 'graphql-tag';

export const WIDGET_SETTINGS = gql`
  query widget($businessOwnerId: Int) {
    widget(businessOwnerId: $businessOwnerId) {
      id
      color
      photo
      languages
      privacyPolicy
      termsAndConditions
    }
    activities(businessOwnerId: $businessOwnerId) {
      id
      title
    }
    accommodations(businessOwnerId: $businessOwnerId) {
      id
      title
    }
  }
`;
